import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    draggable: "true",
    class: "divider",
    onDrag: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dragEvent && _ctx.dragEvent(...args))),
    onDragend: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dragEnd && _ctx.dragEnd(...args)))
  }, null, 32))
}